import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import "../styles/components/category-card.scss";

function CategoryCard({ category, action }) {
  const base_url = process.env.PUBLIC_URL;

  const progressStylesCat = {
    pathColor: "#fff",
    trailColor: "rgba(0, 0, 0, 0.25)",
  };

  return (
    <div className="category-card" key={category.key} style={{ backgroundColor: category.color }} onClick={action}>
      {action && (
        <div className="category-card__dots">
          <span className="category-card__dot"></span>
          <span className="category-card__dot"></span>
          <span className="category-card__dot"></span>
        </div>
      )}
      <CircularProgressbarWithChildren value={category.score} strokeWidth={13} styles={buildStyles(progressStylesCat)}>
        <img className="CircularProgressbar-img" src={`${base_url}/img/${category.icon}`} alt={category.icon} />
        <span className="CircularProgressbar-text">{category.score}%</span>
      </CircularProgressbarWithChildren>
      <div className="category-card__title">{category.title}</div>
    </div>
  );
}

export default CategoryCard;
